import { FC } from "react";
import { ToastContainer as TostifyToastContainer } from "react-toastify";

export const ToastContainer: FC = () => (
  <TostifyToastContainer
    autoClose={4000}
    hideProgressBar
    newestOnTop={true}
    draggable={false}
    icon={true}
  />
);
